import { MutationKey } from '@shared/config';
import type { TFormErrorResponse } from '@shared/types';
import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import type {
  RecoveryPasswordRequest,
  RecoveryPasswordResponse,
} from '../../types';
import { authApi } from '../../authApi';
import { showNotification } from '@shared/utils';
import { useTranslation } from 'react-i18next';

export const useRecoverPassword = (): UseMutationResult<
  RecoveryPasswordResponse,
  AxiosError<TFormErrorResponse>,
  RecoveryPasswordRequest
> => {
  const { t } = useTranslation();
  return useMutation({
    mutationKey: [MutationKey.RECOVER_PASSWORD],
    mutationFn: data => authApi.recoveryPassword(data),
    onSuccess: () => {
      showNotification({
        variant: 'info',
        message: t('auth.recoverPasswordInfo'),
      });
    },
  });
};
